import debounce from '../helpers/debounce';

const $sample = $('.js-sample');
const $form = $sample.find('form');
const $submit = $form.find('button[type=submit]');

const sample = {
  initialize() {
    if ($sample.length) {
      this.email = $sample.find('.js-email-input');

      this.createListeners();
    }
  },

  createListeners() {
    const debouncedCheck = debounce(this.runCheck.bind(this), 200);

    // Listen for changes to the postal fields
    this.email.on('keyup', () => {
      debouncedCheck();
    });
  },

  runCheck() {
    const value = this.email.val().trim().replace(' ', '');
    const expression = /.+@.+\..{2,}/;

    if (value !== '' && !expression.test(String(value).toLowerCase())) {
      this.showError(this.email.data('invalid-message'));
    } else {
      this.hideError();
    }

    this.validateEmail(value);
  },

  showError(error) {
    const element = this.email.parent();
    const errorElement = element.find('.porta-error-message');

    if (errorElement.length) {
      return;
    }

    element.append(`
      <div class="porta-error-message">${error}</div>
    `);

    $submit.prop('disabled', true);
  },

  hideError() {
    const element = this.email.parent();
    const errorElement = element.find('.porta-error-message');

    errorElement.remove();

    $submit.prop('disabled', false);
  },

  validateEmail(email) {
    $.ajax({
      url: $sample.data('api'),
      data: {
        email,
      },
      type: 'POST',
      dataType: 'json',
      error: (err) => {
        this.showError(err.responseJSON.message);
      },
    });
  },
};

export default sample;
